import { forwardRef } from 'react';

import type { IconProps } from './types';

/*
 * DO NOT remove `forwardRef`
 * It is used for `@radix-ui/react-tooltip`
 */
export const HelpOutlined = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={forwardedRef}
    >
      <path
        d="M512 0.070c-281.33 0-512 230.668-512 512 0 281.262 230.668 511.861 512 511.861s512-230.668 512-512c0-281.262-230.668-511.861-512-511.861zM512 103.602c224.872 0 408.468 183.596 408.468 408.329 0 224.872-183.596 408.468-408.468 408.468s-408.468-183.596-408.468-408.329c0-224.872 183.596-408.468 408.468-408.468zM512 258.899c-87.174 0-166.894 61.982-166.894 148.672 0 28.59 23.176 51.766 51.766 51.766v0c28.59 0 51.766-23.176 51.766-51.766v0c0-20.844 22.985-45.14 63.362-45.14s63.362 24.365 63.362 45.278c0 6.557-0.69 7.11-4.969 12.010-7.515 7.331-16.073 13.644-25.418 18.684l-0.603 0.297c-0.093 0.093-0.183 0.183-0.274 0.274l-0.003 0.003c-16.082 9.387-35.408 21.189-52.732 40.723-17.255 19.602-31.128 49.213-31.128 81.721v12.286c0 28.59 23.176 51.766 51.766 51.766v0c28.59 0 51.766-23.176 51.766-51.766v0-12.286c0-7.247 0.69-8.145 5.245-13.252 4.486-5.039 14.149-12.147 26.918-19.671l0.345-0.138c16.012-9.18 34.924-20.914 51.903-40.17 16.979-19.326 30.714-48.452 30.714-80.478 0-86.69-79.72-148.809-166.894-148.809zM511.586 661.569c-28.59 0-51.766 23.176-51.766 51.766v0c0 28.59 23.176 51.766 51.766 51.766v0h0.828c28.59 0 51.766-23.176 51.766-51.766v0c0-28.59-23.176-51.766-51.766-51.766v0z"
        fill={color}
      />
    </svg>
  )
);

export default HelpOutlined;
